import React, { useEffect, useState, useCallback } from 'react';
import { Table, message as antMessage } from 'antd';
import dayjs from 'dayjs';
import { fetchPaymentsForSetting } from '../../../services/chargesApi';

const PaymentsTab = ({ settingId }) => {
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!settingId) return;
    setLoading(true);
    try {
      const data = await fetchPaymentsForSetting(settingId, { page, limit: pageSize });
      setItems(data.payments || []);
      setTotal(data.total || 0);
    } catch {
      antMessage.error('Erro ao carregar pagamentos');
    } finally {
      setLoading(false);
    }
  }, [settingId, page, pageSize]);

  useEffect(() => { load(); }, [load]);

  const columns = [
    { title: 'Jogador', dataIndex: 'player_name', width: 180 },
    { title: 'Telefone', dataIndex: 'player_phone', width: 140 },
    { title: 'Mês ref.', dataIndex: 'reference_month', width: 100 },
    {
      title: 'Valor',
      dataIndex: 'charge_amount',
      width: 110,
      align: 'right',
      render: (v) => `R$ ${(parseFloat(v) || 0).toFixed(2)}`,
    },
    {
      title: 'Pago em',
      dataIndex: 'payment_at',
      width: 150,
      render: (v) => v ? dayjs(v).format('DD/MM/YYYY HH:mm') : '-',
    },
  ];

  return (
    <Table
      rowKey="id"
      loading={loading}
      dataSource={items}
      columns={columns}
      pagination={{
        current: page,
        pageSize,
        total,
        onChange: (p) => setPage(p),
        showSizeChanger: false,
      }}
      scroll={{ x: 'max-content' }}
      size="small"
    />
  );
};

export default PaymentsTab;
